/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaConstMapModel, TGenericBlueprintSchema } from "@adapptio/lib-blueprint";
import { ITreeNode, ITreeNodeAction } from "../TreeViewTypes";

export function createTreeNodesFromMapModel<TMapModel extends ISchemaConstMapModel<TGenericBlueprintSchema>>(
	mapModel: TMapModel,
	{ icon, actions }: { icon: string; actions?: ITreeNodeAction[] }
): ITreeNode[] {
	const mapEntries = mapModel.items;

	const treeNodes: ITreeNode[] = mapEntries.map((mapEntry) => {
		const treeNode: ITreeNode = {
			id: String(mapEntry.key.nodeId),
			label: mapEntry.key.value,
			icon: icon,
			selectable: true,
			actions,
			metaData: {
				mapModel,
				mapEntry
			}
		};

		return treeNode;
	});

	return treeNodes;
}
